import { useQuery } from "@tanstack/react-query";

import { ENDPOINTS } from "@/api/application-api";
import { useAuth } from "@/context/auth-context";
import { Organization } from "@/types/organizations";
import { handleResponse } from "@/utils/errorResponseHandlers";
import { jsonAuthHeaders } from "@/utils/headers";

export const useOrganizations = () => {
  const userToken = useAuth()?.userToken ?? "";
  const url = new URL(ENDPOINTS.organizations);
  return useQuery(
    [ENDPOINTS.organizations],
    (): Promise<{ items: Organization[] }> =>
      fetch(url, {
        method: "GET",
        headers: jsonAuthHeaders(userToken),
      }).then(handleResponse),
  );
};
